(() => {
  const selector = [
    '#MainContent .multicolumn-card',
    '#MainContent .card-wrapper',
    '#MainContent .video-with-text__subheading',
    '#MainContent .video-with-text__text',
    '#MainContent .video-with-text__buttons',
    '#MainContent .collection__title',
    '#MainContent .rich-text__blocks',
    '#MainContent .image-with-text__content',
  ].join(',');
  const factors = [0.58, 1.08, 0.76, 1.24, 0.68, 0.94];
  const states = new Map();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const configuredStrength = Number.parseFloat(document.body.dataset.scrollMotionStrength || '16');
  let frameId = null;

  if (reduceMotion.matches || configuredStrength <= 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const state = states.get(entry.target);

        if (state) state.visible = entry.isIntersecting;
      });
      requestUpdate();
    },
    { rootMargin: '20% 0px 20% 0px' }
  );

  const register = (root = document) => {
    const elements = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];

    elements.forEach((element) => {
      if (states.has(element) || element.closest('[data-scroll-motion-ignore]')) return;

      const sequenceIndex = states.size;
      const factor = Number.parseFloat(element.dataset.scrollMotionFactor || factors[sequenceIndex % factors.length]);
      const strength = Number.parseFloat(element.dataset.scrollMotionStrength || configuredStrength);
      const curve = Number.parseFloat(element.dataset.scrollMotionCurve || '1.4');
      const extra = Number.parseFloat(element.dataset.scrollMotionExtra || '0');

      element.dataset.scrollMotion = '';
      states.set(element, {
        current: 0,
        target: 0,
        currentScale: 1,
        targetScale: 1,
        factor,
        strength,
        curve,
        extra,
        ease: 0.09 + (sequenceIndex % 4) * 0.018,
        featureCard: element.hasAttribute('data-feature-card-motion'),
        scales: element.matches('.multicolumn-card, .card-wrapper') && !element.hasAttribute('data-scroll-motion-no-scale'),
        visible: false,
      });
      observer.observe(element);
    });

    requestUpdate();
  };

  const update = () => {
    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;
    const mobileScale = window.innerWidth < 750 ? 0.65 : 1;
    let keepAnimating = false;

    states.forEach((state, element) => {
      if (!element.isConnected) {
        observer.unobserve(element);
        states.delete(element);
        return;
      }

      if (!state.visible) return;

      const bounds = element.getBoundingClientRect();
      const elementCenter = bounds.top - state.current + bounds.height / 2;
      const range = viewportCenter + bounds.height / 2;
      const rawProgress = Math.max(-1, Math.min(1, (elementCenter - viewportCenter) / range));
      const enteringProgress = Math.max(0, rawProgress);
      const leavingProgress = Math.min(0, rawProgress);
      const easedEntry = enteringProgress * enteringProgress;

      if (state.featureCard && window.innerWidth >= 750) {
        const centeredProgress = Math.abs(rawProgress);

        if (rawProgress > 0.035) {
          state.target =
            Math.pow(enteringProgress, state.curve) *
            Math.max(0, state.strength * state.factor - state.extra);
        } else if (rawProgress < -0.035) {
          state.target =
            -Math.pow(centeredProgress, 1.25) * state.strength * state.factor * 0.42;
        } else {
          state.target = 0;
          state.current = 0;
        }

        state.targetScale = 1;
        state.current += (state.target - state.current) * 0.16;
      } else {
        state.target =
          (easedEntry * state.strength * state.factor +
            leavingProgress * state.strength * state.factor * 0.2) *
          mobileScale;
        state.targetScale = state.scales ? 1 + easedEntry * state.factor * 0.018 * mobileScale : 1;
        state.current += (state.target - state.current) * state.ease;
      }

      state.currentScale += (state.targetScale - state.currentScale) * state.ease;

      if (
        Math.abs(state.target - state.current) > 0.05 ||
        Math.abs(state.targetScale - state.currentScale) > 0.0005
      ) {
        keepAnimating = true;
      }

      element.style.setProperty('--scroll-motion-y', `${state.current.toFixed(2)}px`);
      element.style.setProperty('--scroll-motion-scale', state.currentScale.toFixed(4));
    });

    frameId = keepAnimating ? window.requestAnimationFrame(update) : null;
  };

  function requestUpdate() {
    if (frameId === null) frameId = window.requestAnimationFrame(update);
  }

  register();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
})();
